export function identity<A>(a: A): A {
    return a;
}